export enum AutomaticAssetImportNaming {
  NA = 0,
  ByAssetCatModelNumber = 1,
}
